<div class="header-container">
  <div class="logo-container">
    <a
      (click)="toggleSidebar()"
      href="#"
      class="sidebar-toggle"
      *ngIf="hideMenu !== true"
    >
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a
      class="logo_img logo"
      href="{{ baseHref }}/public"
      aria-label="logo header"
    >
    </a>
  </div>
</div>
<div class="header-container p-0">
  <nb-actions>
    <nb-action class="dark-mode-action">
      <button
        type="button"
        class="dark-mode-toggle nav-btn"
        [attr.aria-label]="isDark ? ('header.darkModeOff' | translate) : ('header.darkModeOn' | translate)"
        (click)="toggleDarkMode()">
        <svg *ngIf="!isDark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26 5.403 5.403 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"/></svg>
        <svg *ngIf="isDark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 0 0 0-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"/></svg>
      </button>
    </nb-action>
    <nb-action class="lang-action">
      <button
        type="button"
        class="lang-badge nav-btn"
        [attr.aria-label]="('header.langLabel' | translate) + ': ' + (currentLang === 'it' ? 'Italiano' : 'English')"
        [attr.aria-expanded]="langMenuOpen"
        (click)="toggleDropdown('lang')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"/></svg>
      </button>
      <div class="a11y-dropdown" *ngIf="langMenuOpen" role="menu" (focusout)="onDropdownFocusOut($event, 'lang')">
        <a *ngFor="let item of langMenu" class="a11y-dropdown__item" role="menuitem" tabindex="0"
           (click)="onLangSelect(item.title); langMenuOpen = false"
           (keydown.enter)="onLangSelect(item.title); langMenuOpen = false"
           (keydown.escape)="langMenuOpen = false">{{ item.title }}</a>
      </div>
    </nb-action>
    <nb-action class="user-action" *ngIf="user; else notLogged">
      <button
        type="button"
        class="user-icon nav-btn"
        [attr.aria-label]="'header.userMenuLoggedIn' | translate"
        [attr.aria-expanded]="userMenuOpen"
        (click)="toggleDropdown('user')"
      >
        <div class="profile-avatar">
          <p>{{ userInitials }}</p>
        </div>
      </button>
      <div class="a11y-dropdown" *ngIf="userMenuOpen" role="menu" (focusout)="onDropdownFocusOut($event, 'user')">
        <a *ngFor="let item of smallDevsMenu" class="a11y-dropdown__item" role="menuitem" tabindex="0"
           [routerLink]="item.link" (click)="userMenuOpen = false"
           (keydown.escape)="userMenuOpen = false">{{ item.title | translate }}</a>
      </div>
    </nb-action>
    <ng-template #notLogged>
      <nb-action class="user-action">
        <button
          type="button"
          class="user-icon nav-btn"
          [attr.aria-label]="'header.userMenuNotLoggedIn' | translate"
          [attr.aria-expanded]="notLoggedMenuOpen"
          (click)="toggleDropdown('notLogged')"
        >
          <nb-icon icon="log-in-outline"></nb-icon>
        </button>
        <div class="a11y-dropdown" *ngIf="notLoggedMenuOpen" role="menu" (focusout)="onDropdownFocusOut($event, 'notLogged')">
          <a *ngFor="let item of notLoggedMenu" class="a11y-dropdown__item" role="menuitem" tabindex="0"
             [routerLink]="item.link" (click)="notLoggedMenuOpen = false"
             (keydown.escape)="notLoggedMenuOpen = false">{{ item.title | translate }}</a>
        </div>
      </nb-action>
    </ng-template>
  </nb-actions>
</div>
